var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c("admin-breadcrumb", {
        attrs: {
          items: [{ text: "Reports", path: { name: "admin-reports" } }],
          name: "Brand Health Scoring",
          title: _vm.pageTitle,
        },
      }),
      _vm._v(" "),
      _c(
        "admin-panel",
        {
          attrs: { "with-header": "" },
          scopedSlots: _vm._u([
            {
              key: "header",
              fn: function () {
                return [
                  _c("div", { staticClass: "d-flex justify-content-between" }, [
                    _c("div", { staticClass: "d-flex" }, [
                      _c(
                        "div",
                        { staticClass: "mr-3" },
                        [
                          _c("strong", { staticClass: "text-uppercase" }, [
                            _vm._v("Start Date:"),
                          ]),
                          _vm._v(
                            " " + _vm._s(_vm.startDate) + "\n            "
                          ),
                          _c("b-form-datepicker", {
                            staticClass: "ml-2",
                            attrs: {
                              max: _vm.maxDate,
                              "button-only": "",
                              "button-variant": "primary",
                            },
                            on: { input: _vm.onStartDateChanged },
                            model: {
                              value: _vm.filters.start_date,
                              callback: function ($$v) {
                                _vm.$set(_vm.filters, "start_date", $$v)
                              },
                              expression: "filters.start_date",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        [
                          _c("strong", { staticClass: "text-uppercase" }, [
                            _vm._v("End Date:"),
                          ]),
                          _vm._v(" " + _vm._s(_vm.endDate) + "\n            "),
                          _c("b-form-datepicker", {
                            staticClass: "ml-2",
                            attrs: {
                              max: _vm.maxDate,
                              "button-only": "",
                              "button-variant": "primary",
                            },
                            on: { input: _vm.onEndDateChanged },
                            model: {
                              value: _vm.filters.end_date,
                              callback: function ($$v) {
                                _vm.$set(_vm.filters, "end_date", $$v)
                              },
                              expression: "filters.end_date",
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      [
                        _c(
                          "b-btn",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true },
                              },
                            ],
                            staticClass: "mr-2",
                            attrs: {
                              variant: "primary",
                              title: "Download CSV",
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.downloadCsv.apply(null, arguments)
                              },
                            },
                          },
                          [_c("b-icon-download")],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-btn",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover",
                                modifiers: { hover: true },
                              },
                            ],
                            attrs: {
                              variant: "primary",
                              title: "Reset Filters",
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.resetFilters.apply(null, arguments)
                              },
                            },
                          },
                          [_c("b-icon-arrow-counterclockwise")],
                          1
                        ),
                      ],
                      1
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
            {
              key: "header-right",
              fn: function () {
                return [
                  _c(
                    "div",
                    { staticClass: "mt-n2 d-flex flex-wrap" },
                    [
                      _c("b-form-select", {
                        staticClass: "w-auto mr-2 my-2",
                        attrs: { options: _vm.healthStatusOptions },
                        on: { change: _vm.loadReportData },
                        model: {
                          value: _vm.filters.health_status,
                          callback: function ($$v) {
                            _vm.$set(_vm.filters, "health_status", $$v)
                          },
                          expression: "filters.health_status",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c("b-table", {
            attrs: {
              fields: _vm.reportColumns,
              items: _vm.reportRows,
              "table-class": "text-nowrap",
              responsive: "",
              hover: "",
              "show-empty": "",
              "empty-text": "No data found",
            },
            scopedSlots: _vm._u([
              {
                key: "head(brand_name)",
                fn: function (data) {
                  return [
                    _c(
                      "span",
                      {
                        staticClass: "sortable-column",
                        on: {
                          click: function ($event) {
                            return _vm.toggleSort("brand_name")
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(data.label) +
                            " " +
                            _vm._s(_vm.renderSortIcon("brand_name")) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "head(integration_status)",
                fn: function (data) {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-inline-flex align-items-center" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "sortable-column",
                            on: {
                              click: function ($event) {
                                return _vm.toggleSort("integration_status")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(data.label) +
                                " " +
                                _vm._s(
                                  _vm.renderSortIcon("integration_status")
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.top",
                                modifiers: { hover: true, top: true },
                              },
                            ],
                            staticClass:
                              "kpi-header-info ml-1 d-inline-flex align-items-center text-muted",
                            attrs: {
                              title:
                                _vm.getKpiHeaderTooltip("integration_status"),
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                              },
                            },
                          },
                          [_c("b-icon-info-circle")],
                          1
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "head(live_sku_count)",
                fn: function (data) {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-inline-flex align-items-center" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "sortable-column",
                            on: {
                              click: function ($event) {
                                return _vm.toggleSort("live_sku_count")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(data.label) +
                                " " +
                                _vm._s(_vm.renderSortIcon("live_sku_count")) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.top",
                                modifiers: { hover: true, top: true },
                              },
                            ],
                            staticClass:
                              "kpi-header-info ml-1 d-inline-flex align-items-center text-muted",
                            attrs: {
                              title: _vm.getKpiHeaderTooltip("live_sku_count"),
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                              },
                            },
                          },
                          [_c("b-icon-info-circle")],
                          1
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "head(gl_listing_rate)",
                fn: function (data) {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-inline-flex align-items-center" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "sortable-column",
                            on: {
                              click: function ($event) {
                                return _vm.toggleSort("gl_listing_rate")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(data.label) +
                                " " +
                                _vm._s(_vm.renderSortIcon("gl_listing_rate")) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.top",
                                modifiers: { hover: true, top: true },
                              },
                            ],
                            staticClass:
                              "kpi-header-info ml-1 d-inline-flex align-items-center text-muted",
                            attrs: {
                              title: _vm.getKpiHeaderTooltip("gl_listing_rate"),
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                              },
                            },
                          },
                          [_c("b-icon-info-circle")],
                          1
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "head(order_source_mix)",
                fn: function (data) {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-inline-flex align-items-center" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "sortable-column",
                            on: {
                              click: function ($event) {
                                return _vm.toggleSort("order_source_mix")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(data.label) +
                                " " +
                                _vm._s(_vm.renderSortIcon("order_source_mix")) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.top",
                                modifiers: { hover: true, top: true },
                              },
                            ],
                            staticClass:
                              "kpi-header-info ml-1 d-inline-flex align-items-center text-muted",
                            attrs: {
                              title:
                                _vm.getKpiHeaderTooltip("order_source_mix"),
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                              },
                            },
                          },
                          [_c("b-icon-info-circle")],
                          1
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "head(retail_orders_placed)",
                fn: function (data) {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-inline-flex align-items-center" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "sortable-column",
                            on: {
                              click: function ($event) {
                                return _vm.toggleSort("retail_orders_placed")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(data.label) +
                                " " +
                                _vm._s(
                                  _vm.renderSortIcon("retail_orders_placed")
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.top",
                                modifiers: { hover: true, top: true },
                              },
                            ],
                            staticClass:
                              "kpi-header-info ml-1 d-inline-flex align-items-center text-muted",
                            attrs: {
                              title: _vm.getKpiHeaderTooltip(
                                "retail_orders_placed"
                              ),
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                              },
                            },
                          },
                          [_c("b-icon-info-circle")],
                          1
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "head(wow_order_volume)",
                fn: function (data) {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-inline-flex align-items-center" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "sortable-column",
                            on: {
                              click: function ($event) {
                                return _vm.toggleSort("wow_order_volume")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(data.label) +
                                " " +
                                _vm._s(_vm.renderSortIcon("wow_order_volume")) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.top",
                                modifiers: { hover: true, top: true },
                              },
                            ],
                            staticClass:
                              "kpi-header-info ml-1 d-inline-flex align-items-center text-muted",
                            attrs: {
                              title:
                                _vm.getKpiHeaderTooltip("wow_order_volume"),
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                              },
                            },
                          },
                          [_c("b-icon-info-circle")],
                          1
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "head(inventory_freshness)",
                fn: function (data) {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-inline-flex align-items-center" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "sortable-column",
                            on: {
                              click: function ($event) {
                                return _vm.toggleSort("inventory_freshness")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(data.label) +
                                " " +
                                _vm._s(
                                  _vm.renderSortIcon("inventory_freshness")
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.top",
                                modifiers: { hover: true, top: true },
                              },
                            ],
                            staticClass:
                              "kpi-header-info ml-1 d-inline-flex align-items-center text-muted",
                            attrs: {
                              title: _vm.getKpiHeaderTooltip(
                                "inventory_freshness"
                              ),
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                              },
                            },
                          },
                          [_c("b-icon-info-circle")],
                          1
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "head(time_to_first_value)",
                fn: function (data) {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-inline-flex align-items-center" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "sortable-column",
                            on: {
                              click: function ($event) {
                                return _vm.toggleSort("time_to_first_value")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(data.label) +
                                " " +
                                _vm._s(
                                  _vm.renderSortIcon("time_to_first_value")
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.top",
                                modifiers: { hover: true, top: true },
                              },
                            ],
                            staticClass:
                              "kpi-header-info ml-1 d-inline-flex align-items-center text-muted",
                            attrs: {
                              title: _vm.getKpiHeaderTooltip(
                                "time_to_first_value"
                              ),
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                              },
                            },
                          },
                          [_c("b-icon-info-circle")],
                          1
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "head(multi_user_engagement)",
                fn: function (data) {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-inline-flex align-items-center" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "sortable-column",
                            on: {
                              click: function ($event) {
                                return _vm.toggleSort("multi_user_engagement")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(data.label) +
                                " " +
                                _vm._s(
                                  _vm.renderSortIcon("multi_user_engagement")
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.top",
                                modifiers: { hover: true, top: true },
                              },
                            ],
                            staticClass:
                              "kpi-header-info ml-1 d-inline-flex align-items-center text-muted",
                            attrs: {
                              title: _vm.getKpiHeaderTooltip(
                                "multi_user_engagement"
                              ),
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                              },
                            },
                          },
                          [_c("b-icon-info-circle")],
                          1
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "head(payment_status)",
                fn: function (data) {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-inline-flex align-items-center" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "sortable-column",
                            on: {
                              click: function ($event) {
                                return _vm.toggleSort("payment_status")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(data.label) +
                                " " +
                                _vm._s(_vm.renderSortIcon("payment_status")) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.top",
                                modifiers: { hover: true, top: true },
                              },
                            ],
                            staticClass:
                              "kpi-header-info ml-1 d-inline-flex align-items-center text-muted",
                            attrs: {
                              title: _vm.getKpiHeaderTooltip("payment_status"),
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                              },
                            },
                          },
                          [_c("b-icon-info-circle")],
                          1
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "head(fulfillment_hub_usage)",
                fn: function (data) {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-inline-flex align-items-center" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "sortable-column",
                            on: {
                              click: function ($event) {
                                return _vm.toggleSort("fulfillment_hub_usage")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(data.label) +
                                " " +
                                _vm._s(
                                  _vm.renderSortIcon("fulfillment_hub_usage")
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.top",
                                modifiers: { hover: true, top: true },
                              },
                            ],
                            staticClass:
                              "kpi-header-info ml-1 d-inline-flex align-items-center text-muted",
                            attrs: {
                              title: _vm.getKpiHeaderTooltip(
                                "fulfillment_hub_usage"
                              ),
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                              },
                            },
                          },
                          [_c("b-icon-info-circle")],
                          1
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "head(overall_kpi_score)",
                fn: function (data) {
                  return [
                    _c(
                      "div",
                      { staticClass: "d-inline-flex align-items-center" },
                      [
                        _c(
                          "span",
                          {
                            staticClass: "sortable-column",
                            on: {
                              click: function ($event) {
                                return _vm.toggleSort("overall_kpi_score")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(data.label) +
                                " " +
                                _vm._s(
                                  _vm.renderSortIcon("overall_kpi_score")
                                ) +
                                "\n          "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "span",
                          {
                            directives: [
                              {
                                name: "b-tooltip",
                                rawName: "v-b-tooltip.hover.top",
                                modifiers: { hover: true, top: true },
                              },
                            ],
                            staticClass:
                              "kpi-header-info ml-1 d-inline-flex align-items-center text-muted",
                            attrs: {
                              title:
                                _vm.getKpiHeaderTooltip("overall_kpi_score"),
                            },
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                              },
                            },
                          },
                          [_c("b-icon-info-circle")],
                          1
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "cell(integration_status)",
                fn: function (data) {
                  return [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover",
                            modifiers: { hover: true },
                          },
                        ],
                        attrs: {
                          title: data.item.integration_status_info || "",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.renderStatusIcon(data.item.integration_status)
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "cell(live_sku_count)",
                fn: function (data) {
                  return [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover",
                            modifiers: { hover: true },
                          },
                        ],
                        attrs: { title: data.item.live_sku_count_info || "" },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.renderStatusIcon(data.item.live_sku_count)
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "cell(gl_listing_rate)",
                fn: function (data) {
                  return [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover",
                            modifiers: { hover: true },
                          },
                        ],
                        attrs: { title: data.item.gl_listing_rate_info || "" },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.renderStatusIcon(data.item.gl_listing_rate)
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "cell(order_source_mix)",
                fn: function (data) {
                  return [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover",
                            modifiers: { hover: true },
                          },
                        ],
                        attrs: { title: data.item.order_source_mix_info || "" },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.renderStatusIcon(data.item.order_source_mix)
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "cell(retail_orders_placed)",
                fn: function (data) {
                  return [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover",
                            modifiers: { hover: true },
                          },
                        ],
                        attrs: {
                          title: data.item.retail_orders_placed_info || "",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.renderStatusIcon(
                                data.item.retail_orders_placed
                              )
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "cell(wow_order_volume)",
                fn: function (data) {
                  return [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover",
                            modifiers: { hover: true },
                          },
                        ],
                        attrs: { title: data.item.wow_order_volume_info || "" },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.renderStatusIcon(data.item.wow_order_volume)
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "cell(inventory_freshness)",
                fn: function (data) {
                  return [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover",
                            modifiers: { hover: true },
                          },
                        ],
                        attrs: {
                          title: data.item.inventory_freshness_info || "",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.renderStatusIcon(
                                data.item.inventory_freshness
                              )
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "cell(time_to_first_value)",
                fn: function (data) {
                  return [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover",
                            modifiers: { hover: true },
                          },
                        ],
                        attrs: {
                          title: data.item.time_to_first_value_info || "",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.renderStatusIcon(
                                data.item.time_to_first_value
                              )
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "cell(multi_user_engagement)",
                fn: function (data) {
                  return [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover",
                            modifiers: { hover: true },
                          },
                        ],
                        attrs: {
                          title: data.item.multi_user_engagement_info || "",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.renderStatusIcon(
                                data.item.multi_user_engagement
                              )
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "cell(payment_status)",
                fn: function (data) {
                  return [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover",
                            modifiers: { hover: true },
                          },
                        ],
                        attrs: { title: data.item.payment_status_info || "" },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.renderStatusIcon(data.item.payment_status)
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "cell(fulfillment_hub_usage)",
                fn: function (data) {
                  return [
                    _c(
                      "span",
                      {
                        directives: [
                          {
                            name: "b-tooltip",
                            rawName: "v-b-tooltip.hover",
                            modifiers: { hover: true },
                          },
                        ],
                        attrs: {
                          title: data.item.fulfillment_hub_usage_info || "",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.renderStatusIcon(
                                data.item.fulfillment_hub_usage
                              )
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }